import { Add, Remove } from '@mui/icons-material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import util from './util/index.js';
import appConfig from './config/appConfig.js';

dayjs.extend(utc)

const getRoleValues = function () {
	let operatorId = null, departmentId = null, supervisorRoleId = null, superAdminId = null, administratorId, viewerId = null, huluAdminId = null, superAdministratorId = null;
	if (util.localData && util.localData.loginData) {
		const parseData = util.localData.loginData;
		const tags = parseData.tags;
		operatorId = tags.OperatorId;
		departmentId = tags.DepartmentId;
		supervisorRoleId = tags.SupervisorRoleId;
		superAdminId = tags.SuperAdminId;
		administratorId = tags.AdministratorRoleId;
		viewerId = tags.ViewerRoleId;
		huluAdminId = tags.HuluAdminRoleId;
		superAdministratorId = tags.SuperAdministratorRoleId;
	}
	return { operatorId, departmentId, supervisorRoleId, superAdminId, administratorId, viewerId, huluAdminId, superAdministratorId };
}
const isNodeServer = true;
const isLocal = window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('192.168') > -1;

// Use runtime config if set, otherwise fall back to dynamic URL calculation
let url = appConfig.ApiUrl || '';

if (!url) {
	// Fallback to dynamic URL calculation if env var not set
	if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
		window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
	}
	url = window.location.origin;
	const dir = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'));
	if (isLocal) {
		if (window.location.port) {
			url = url.replace(':' + window.location.port, isNodeServer ? window.location.port === "3000" ? ":" + (import.meta.env.VITE_DEV_PORT_FALLBACK || "8082") : ":" + window.location.port : '/CATViewer');
		} else {
			if (dir && dir.length > 0) {
				url += dir;
			}
			else {
				url += isNodeServer ? window.location.protocol === 'https:' ? ':' + (import.meta.env.VITE_PRODUCTION_HTTPS_PORT || '443') : window.location.protocol === 'http:' ? ':' + (import.meta.env.VITE_PRODUCTION_HTTP_PORT || '80') : '/CAT/' : '/CAT/';
			}
		}
	} else {
		if (dir && dir.length > 0) {
			url += dir;
		}
	}
}


export default {
	hostURL: {
		URL: url
	},
	isNodeServer: isNodeServer,
	viewerArray: ['Viewer'],
	adminViewerArray: ['Administrator', 'Viewer'],
	LanguageLookupType: [
		{ LookupId: 'en', DisplayValue: 'English' },
		{ LookupId: 'fre', DisplayValue: 'French' },
		{ LookupId: 'de', DisplayValue: 'German' },
		{ LookupId: 'it', DisplayValue: 'Italian' },
		{ LookupId: 'es', DisplayValue: 'Spanish' },
		{ LookupId: 'pt', DisplayValue: 'Portuguese ' }
	],
	ChartGrouplookupType: [
		{ LookupId: 'CycleStatus', DisplayValue: 'CycleStatus' },
		{ LookupId: 'OperatorName', DisplayValue: 'Operator' },
		{ LookupId: 'CycleName', DisplayValue: 'CycleType' },
		{ LookupId: 'Month', DisplayValue: 'Month' },
		{ LookupId: 'Week', DisplayValue: 'Week' },
		{ LookupId: 'Day', DisplayValue: 'Day' },
		{ LookupId: 'CycleActionStatus', DisplayValue: 'ReviewStatus' },
		{ LookupId: 'EquipmentName', DisplayValue: 'EquipmentList' },
		{ LookupId: 'EquipmentTypeName', DisplayValue: 'EquipmentType' },
		{ LookupId: 'FaultId', DisplayValue: 'FaultCode' }
	],
	ThemeLookupType: [
		{ LookupId: 'blue', DisplayValue: 'Default Theme' },
		{ LookupId: 'black', DisplayValue: 'Dark Theme' }
	],
	Period: ['Month', 'Week', 'Day'],
	PeriodCombo: [
		{
			value: 'Month',
			label: 'LastMonth'
		},
		{
			value: 'Week',
			label: 'LastWeek'
		},
		{
			value: 'Day',
			label: 'Today'
		}
	],
	ChartValueType: [{ LookupId: 'RecordCount', DisplayValue: 'RecordCount' }],
	ChartTypes: [
		{ LookupId: 'Pie', DisplayValue: 'PieChart' },
		{ LookupId: 'Column', DisplayValue: 'ColumnChart' },
		{ LookupId: 'Stacked', DisplayValue: 'StackedChart' }
	],
	CombinationChartTypes: [
		{ LookupId: 'line', DisplayValue: 'LineChart' },
		{ LookupId: 'column', DisplayValue: 'ColumnChart' }
	],
	MomentFormat: {
		DateTimeFormat: 'MM/DD/YYYY HH:mm:ss',
		DateTimeFormatAMPM: 'MM/DD/YYYY hh:mm:ss A',
		DateTimeFormatNoSecsAMPM: 'MM/DD/YYYY hh:mm A',
		TimeFormat: 'HH:mm:ss',
		TimeFormatNoSecondAMPM: 'hh:mm A',
		Date: 'YYYY-MM-DD',
		DateMonthYear: 'DD-MM-YYYY',
		MonthDateYear: 'MM/DD/YYYY',
		DateTime24Hour: 'YYYY-MM-DD HH:mm:ss',
		DateTimeFormatSecondAMPM: 'MM-DD-YYYY  hh:mm:ss A',
		LogsDateFormat: 'MM-DD-YYYY',
		FormateDateTimeWithMillisecond: "YYYY-MM-DDTHH:mm:ss.SSS",
		TimeStampFormat: "YYYY-DD-MMTHH-mm-ss",
	},
	LeakTest: {
		Blocked: 0.75,
		Pass: 2.5,
		Disconnected: 4.25,
		ConnectionError: 5
	},
	ConnectivityType: {
		PlugAndPlay: !isNodeServer ? 48 : '6123c4f779f0fa4c6ccab572',
		Kodiak: !isNodeServer ? 49 : '6123c4f779f0fa4c6ccab573',
		None: !isNodeServer ? 153 : '6123c4f779f0fa4c6ccab574',
		Proconnect: !isNodeServer ? 192 : '6123c4f779f0fa4c6ccab575',
		CATSync: !isNodeServer ? 194 : '6123c4f779f0fa4c6ccab576',
		Directory: !isNodeServer ? 234 : '6123c4f779f0fa4c6ccab579',
		AMSCO600EU: !isNodeServer ? 204 : '6123c4f779f0fa4c6ccab577',
		CSVConvert: !isNodeServer ? 221 : '6123c4f779f0fa4c6ccab578',
		Advantage: !isNodeServer ? 253 : '61f4122c056dc61044d087c9',
		EndoCabinet: !isNodeServer ? 252 : '61f41216056dc61044d087c8',
		Washer: !isNodeServer ? 1 : '612743ffc148926e3c177ac6',
	},
	DefaultValues: {
		IntegerNull: -9999
	},
	Roles: {
		get SuperAdmin() { return !isNodeServer ? 1 : getRoleValues().superAdminId; },
		get Operator() { return !isNodeServer ? 3 : getRoleValues().operatorId; },
		get Supervisor() { return !isNodeServer ? 2 : getRoleValues().supervisorRoleId; },
		get Department() { return !isNodeServer ? 4 : getRoleValues().departmentId; }
	},
	getRoles: () => ({
		SuperAdmin: !isNodeServer ? 1 : getRoleValues().superAdminId,
		Operator: !isNodeServer ? 3 : getRoleValues().operatorId,
		Supervisor: !isNodeServer ? 2 : getRoleValues().supervisorRoleId,
		Department: !isNodeServer ? 4 : getRoleValues().departmentId,
		Administrator: !isNodeServer ? 5 : getRoleValues().administratorId,
		Viewer: !isNodeServer ? 6 : getRoleValues().viewerId,
		SuperAdministrator: !isNodeServer ? 4 : getRoleValues().superAdministratorId,
		HuluAdmin: !isNodeServer ? 4 : getRoleValues().huluAdminId
	}),
	IndicatorType: {
		BI: '1',
		CI: '2'
	},
	CycleStatus: {
		Pass: 0,
		Aborted: 1,
		Halt: 2,
		AdvantageCyclePass: 100,
		OkWithErrors: 101,
		OkWithNoSCUMonitoring: 102,
		StoppedByOperator: 120,
		StoppedByFailure: 121,
		FailedInterruptedCycle: 130,
		FailedLioCause: 140,
		FailedSaftyControllerCause: 150
	},
	TaskStatus: {
		Due: !isNodeServer ? 46 : '6123c4f679f0fa4c6ccab506',
		Complete: !isNodeServer ? 47 : '6123c4f679f0fa4c6ccab507',
		PastDue: !isNodeServer ? 142 : '6123c4f679f0fa4c6ccab508',
		ClosedNoAction: !isNodeServer ? 143 : '6123c4f679f0fa4c6ccab509',
		InComplete: !isNodeServer ? 179 : '6123c4f679f0fa4c6ccab50a'
	},
	EquipmentType: {
		WASHER: !isNodeServer ? 1 : '612743ffc148926e3c177ac6',
		STEAMSTERILIZER: !isNodeServer ? 2 : '612743ffc148926e3c177ac8',
		STERILIZER: !isNodeServer ? 3 : '612743ffc148926e3c177aca',
		INCUBATOR: !isNodeServer ? 4 : '612743ffc148926e3c177acc',
		ENDOWASHER: !isNodeServer ? 5 : '612743ffc148926e3c177ace',
		VHPSTERILIZER: !isNodeServer ? 6 : '612743ffc148926e3c177ad0',
		LIQUIDCHEMICAL: !isNodeServer ? 7 : '612743ffc148926e3c177ad2',
		DRYINGCABINET: !isNodeServer ? 8 : '612743ffc148926e3c177ad4',
		ULTRASONIC: !isNodeServer ? 9 : '612743ffc148926e3c177ad6',
		CABINET: !isNodeServer ? 10 : '61f3e706056dc61044d087a2',
		AER: !isNodeServer ? 11 : '61f3e706056dc61044d087a3',
		ENDOCABINET: '6513528f15d865f2f425d213',
		ADV: '6513529865d3d0829129f8b1',
		TrackingSystem: '612743ffc148926e3c177ac3',
		ExtarnalTrackingSystem: '612743ffc148926e3c177ac4',
		ENSPIRE3000: '612743ffc148926e3c177ad2'
	},
	ModelType: {
		CenturyMedium: !isNodeServer ? 1 : '62f239f38718bd4d744c5da2',
		CenturySmall: !isNodeServer ? 2 : '62f23a058718bd4d744c5da3',
		AMSCO400: !isNodeServer ? 3 : '62f23a1a8718bd4d744c5da4',
		Evolution: !isNodeServer ? 4 : '62f23a348718bd4d744c5da5',
		AMSCO600EU: !isNodeServer ? 5 : '62f23abe8718bd4d744c5daa',
		AMSCO600US: !isNodeServer ? 6 : '62f23b058718bd4d744c5daf',
		VPRO1: !isNodeServer ? 7 : '62f23a438718bd4d744c5da6',
		VPROMAX: !isNodeServer ? 8 : '62f23a638718bd4d744c5da7',
		VPROMAX2: !isNodeServer ? 9 : '62f23a848718bd4d744c5da8',
		VPROS2: !isNodeServer ? 10 : '62f23a978718bd4d744c5da9',
		Synergy: !isNodeServer ? 11 : '62f23b1c8718bd4d744c5db0',
		VisionMultiChamber: !isNodeServer ? 12 : '62f23b6c8718bd4d744c5db1',
		VisionSingleChamber: !isNodeServer ? 13 : '62f23b828718bd4d744c5db2',
		Vision1300series: !isNodeServer ? 14 : '62f23b968718bd4d744c5db3',
		Reliance1227: !isNodeServer ? 15 : '62f23bc08718bd4d744c5db4',
		AMSCO3052: !isNodeServer ? 16 : '62f23bd88718bd4d744c5db5',
		AMSCO5052: !isNodeServer ? 17 : '62f23cd48718bd4d744c5dc6',
		AMSCO7053L: !isNodeServer ? 18 : '62f23bea8718bd4d744c5db6',
		AMSCO7052HP: !isNodeServer ? 19 : '62f23bfd8718bd4d744c5db7',
		AMSCO7053HP: !isNodeServer ? 20 : '62f23c108718bd4d744c5db8',
		AMSCO1215: !isNodeServer ? 21 : '62f23c1d8718bd4d744c5db9',
		System1Endo2: !isNodeServer ? 22 : '62f23c2c8718bd4d744c5dba',
		PTX: !isNodeServer ? 23 : '62f23c398718bd4d744c5dbb',
		Enspire300SeriesAER: !isNodeServer ? 24 : '62f23c488718bd4d744c5dbc',
		RelianceCabinet: !isNodeServer ? 25 : '62f23c6a8718bd4d744c5dbd',
		ADV: !isNodeServer ? 26 : '62f2395f8718bd4d744c5d9f',
		EndoDry: !isNodeServer ? 27 : '62f23cc68718bd4d744c5dc4',
		CeleritySteam: !isNodeServer ? 28 : '62f23c798718bd4d744c5dbe',
		CelerityHP: !isNodeServer ? 29 : '62f23c898718bd4d744c5dbf',
		AssertSteam: !isNodeServer ? 30 : '62f23ca58718bd4d744c5dc3',
		UniversalIncubator: !isNodeServer ? 31 : '62f23cd48718bd4d744c5dc5',
		WasherCart: !isNodeServer ? 33 : '63c69d9d08f3965f2442a5f4',
		NonSterisHp: '635f6a1f7e7b223fee2098a4',
		NonSterisSteam: '635f6a157e7b223fee209875'
	},
	Attachment: {
		AssociationType: 1,
		AttachmentType: 1
	},
	Task: {
		AssociationType: 2,
		AttachmentType: 2
	},
	ScreenType: {
		Tablet: 1024,
		Desktop: 1600,
		Mobile: 768
	},
	TinNo: '01',
	BarcodeApplicationIdentifier: {
		ExpiryDate: '17',
		LotOrBatchNo: '10',
		SerialNumber: '21',
		BarcodeSerialNumber: '18',
		SerialNo: '91'
	},
	LoggedInUser: {
		LoggedIn: 'LoggedIn'
	},
	DecimalMark: {
		Comma: 'comma'
	},
	ModalityType: {
		Incubator: 'Incubator'
	},
	DashboardActiveTab: {
		Cycle: 'Cycle',
		Equipment: 'Equipment'
	},
	TestOrControl: {
		Test: 0,
		Control: 1
	},
	BIResult: {
		Positive: 1,
		Negative: 2,
		Error: 3,
		Pending: 0
	},
	BIResultColor: {
		Red: 'red',
		Green: '#1ab394'
	},
	Default: {
		value: 0
	},
	TimeFormat: {
		StandardFormat: '12 hour',
		MilitaryFormat: '24 hour'
	},
	PasswordStrength: {
		Easy: '^(?=.*[A-Z])(?=\\S+$).{8,50}$',
		Medium: '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\\S+$).{8,50}$',
		Strong: '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\\S+$).{8,50}$'
	},
	CIResult: {
		Check: 1,
		Cross: 2
	},
	CycleReviewAccess: {
		CanReview: '1'
	},
	EquipmentStatusType: {
		Connected: 1
	},
	LoadReleaseType: {
		Biological: !isNodeServer ? 64 : '6123c4f779f0fa4c6ccab5aa',
		Parametric: !isNodeServer ? 65 : '6123c4f779f0fa4c6ccab5ab'
	},
	EquipmentFamilyType: {
		IncubatorSteam: !isNodeServer ? 7 : '612743ffc148926e3c177ae5',
		IncubatorVHP: !isNodeServer ? 8 : '612743ffc148926e3c177ae7',
		STEAMEUSTERILIZER: !isNodeServer ? 11 : '612743ffc148926e3c177aed',
		AMSCOEUSTERILIZER: !isNodeServer ? 29 : '612743ffc148926e3c177b11',
		WASHERCART: !isNodeServer ? 4 : '612743ffc148926e3c177adf',
		ADVANTAGE: !isNodeServer ? 33 : '61f3fa6a056dc61044d087c4',
		RAPIDAER: !isNodeServer ? 33 : '65149d2fd65ff61314242cc4',
		NONSTERISSTEAM: !isNodeServer ? 34 : '621f20b649af30a72e014303',
		NONSTERISHP: !isNodeServer ? 35 : '621f20b649af30a72e01430a',
		ENSPIRE: '612743ffc148926e3c177ae0',
		INCUBATORUNIVERSAL: '612743ffc148926e3c177abc',
		LIQUIDCHEMICALSYSTEM1ENDO: '612743ffc148926e3c177aef',
		ENSPIRE3000: '64a6f2c2c1a2ee1083be1e91',
		LIQUIDCHEMICALENSPIRE3000: '64a6f2c2c1a2ee1083be1e91',
		AERXML: '65d8889995a4821583eb2dc4',
		AERDSD: '65d8884355a4821583eb2dc4'
	},
	RoleName: {
		SuperAdmin: 'STERIS Admin',
		STERISSpecialist: 'STERIS Specialist',
		Operator: 'Operator',
		Department: 'Department',
		Supervisor: 'Supervisor',
		SterisAdmin: 'STERIS Admin',
		Superadmin: 'SuperAdmin'
	},
	ResponseText: {
		PasswordChanged: 'PasswordChanged'
	},
	AccountStatus: {
		Locked: 1,
		Unlocked: 0
	},
	InvalidAttempt: {
		MaxTries: 5
	},
	TaskType: {
		Maintenance: !isNodeServer ? 139 : '6123c4f779f0fa4c6ccab63e',
		Cycle: !isNodeServer ? 140 : '6123c4f779f0fa4c6ccab63f',
		Indicator: !isNodeServer ? 141 : '6123c4f779f0fa4c6ccab640'
	},
	DateTime: {
		MinDate: dayjs.utc([1990, 1, 1]),
		MinApplicationDate: '2000-01-01'
	},
	AutoRefresh: {
		DefaultSec: 60000 * 5
	},
	FlowCheckStatus: {
		Pass: 1,
		PassWithCondition: 2,
		Empty: 0
	},
	CycleName: {
		Endoscope: 'ENDOSCOPE',
		DECONTAMINATION: 'DECONTAMINATION'
	},
	BottomFlow: {
		First: 1,
		Last: 7
	},
	SterilizerPrint: {
		Content: '<PrinterLines />'
	},
	CycleTabName: {
		LeakTest: 'LEAKTEST',
		THERMALDISINPASS: 'THERMALDISINPASS'
	},
	ResultType: {
		BIResult: 'BIResult',
		CIResult: 'CIResult',
		STSResult: 'STSResult'
	},
	PumpType: {
		PAA: 'Pump 2 And 3',
		Glut: 'Pump 3',
		None: 'None',
		Pump0: 'Pump 0'
	},
	LotNumberType: {
		CILotNumber: 'CILotNumber',
		BILotNumber: 'BILotNumber'
	},
	CycleGraph: {
		Small: !isNodeServer ? 180 : '6123c4f879f0fa4c6ccab652',
		Large: !isNodeServer ? 181 : '6123c4f879f0fa4c6ccab653'
	},
	StockChartWidth: {
		Large: 1460,
		Medium: 1100
	},
	StockChartHeight: {
		Height: 400
	},
	DefaultValue: 'PASS',
	BarcodeReadType: {
		Indicator: '00'
	},
	EndoSystemOperator: {
		OperatorName: 'OperatorName'
	},
	True: 'True',
	EquipmentTypeName: {
		WASHER: 'WASHER',
		STEAMSTERILIZER: 'STEAMSTERILIZER',
		STERILIZER: 'STERILIZER',
		INCUBATOR: 'INCUBATOR',
		ENDOWASHER: 'ENDO-WASHER',
		VHPSTERILIZER: 'VHPSTERILIZER',
		LIQUIDCHEMICAL: 'LIQUIDCHEMICAL',
		DRYINGCABINET: 'DRYING CABINET',
		ENODCABINET: 'CABINET'
	},
	ThermalAO: {
		1: 'A0 600',
		2: 'A0 600 Low Temp 1',
		3: 'A0 600 Low Temp 2',
		4: 'A0 3000 Low Temp',
		5: 'A0 3000',
		6: 'A0 12000',
		NA: 'NA'
	},
	AcknowledgeStatus: {
		True: 1
	},
	SterilizeStatus: {
		True: true
	},
	PrintPropetiesTopSection: {
		WasherCycleTopSection: 'WasherCycleTopSection',
		EndoWasherTopSection: 'EndoWasherTopSection',
		WasherTopSection: 'WasherTopSection',
		DecontamCycleTopSection: 'DecontamCycleTopSection'
	},
	CycleStatusValue: {
		POWERFAILED: 'POWER FAILED',
		PASS: 'PASS',
		ABORTED: 'ABORTED'
	},
	BIResultIcon: {
		Pending: 'fa-ellipsis-h-orange',
		Error: 'fa-exclamation-red',
		TestPositive: 'fa-plus-red',
		TestNegative: 'fa-minus-green',
		ControlPositive: 'fa-minus-red',
		ControlNegative: 'fa-plus-green'
	},
	FilterTypeTimeout: 500,
	skipCriticalParamsArr: ['WARMUP', 'PASSTHROUGH', 'CUPDISPOSE', 'RESDISPOSE'],
	WasherTopSection: {
		WASHERCIRESULTICON: 'WasherCIResultIcon',
		WASHERCILOTNUMBER: 'WasherCILotNumber'
	},
	EquipmentDateFormat: {
		Default: !isNodeServer ? 220 : '6123c4f879f0fa4c6ccab688'
	},
	LanguageName: {
		default: !isNodeServer ? 1 : '6124ce10677de3668816e646' // English language Id
	},
	CATDefaultPort: {
		port: 8082
	},
	EquipmentFamily: {
		NONSTERISHP: 'Non-Steris HP',
		NONSTERISSTEAM: 'Non-Steris Steam'
	},
	DeviceTypeWithSN: ['S', 'V', 'W', 'E', 'I', 'L', 'A'],
	DeviceTypeWithRFID: ['RM'],
	TopicType: {
		Data: '+/data',
		TelemetryData: '+/tdata',
		CommandData: '+/cmd',
		DataWildcard: 'data/#',
		TelemetryDataWildcard: 'tdata/#',
		CommandDataWildcard: 'cmd/#'
	},
	PublishTopics: [
		{ value: 'UserSync', label: 'User Sync' },
		{ value: 'ItemSync', label: 'Item Sync' },
		{ value: 'EquipmentSync', label: 'Equipment Sync' },
		{ value: 'TransactionSync/#', label: 'Transaction Sync' },
		{ value: 'HospitalSync', label: 'Hospital Sync' },
		{ value: 'FileSync', label: 'File Sync' },
		{ value: '+/data', label: 'Data' },
		{ value: '+/tdata', label: 'Telemetry Data' },
		{ value: '+/cmd', label: 'Command Data' }
	],
	SubscribeTopics: [
		{ value: 'UserSync', label: 'User Sync' },
		{ value: 'ItemSync', label: 'Item Sync' },
		{ value: 'EquipmentSync', label: 'Equipment Sync' },
		{ value: 'TransactionSync/#', label: 'Transaction Sync' },
		{ value: 'HospitalSync', label: 'Hospital Sync' },
		{ value: 'FileSync', label: 'File Sync' },
		{ value: 'ExecuteCommand', label: 'Execute Command' },
		{ value: '+/data', label: 'Data' },
		{ value: '+/tdata', label: 'Telemetry Data' },
		{ value: '+/cmd', label: 'Command Data' }
	],
	refreshTime: 3000,
	defaultPageSize: 50,
	AppName: {
		CatSync: 'CAT Sync',
		CatViewer: 'CAT Viewer',
	},
	minCatSyncVersion: '2.1',
	LookupType: {
		DataTopics: '61406d42d22e08692c7c7c3f',
		TDataTopics: '61406f68d22e08692c7c7c4e',
		CMDDataTopics: '61406f68d22e08692c7c7c4f',
		SubTopics: '61407721d22e08692c7c7c7b',
		PubTopics: '613f31e0f2bbbc48ec1552b1',
		UserSyncParameters: '6123c4eb79f0fa4c6ddab4c7',
		ItemSyncParameters: '6123c4eb79f0fa4c6ddab4c8',
		EndoUserType: '64adc0861dac76fb8e8b3515',
		CommandServices: '64adc0861dac76fb8e8b3519'
	},
	dbNameValidationMsg: `Database name on Windows server cannot contains any character of /. \\"$*<>:|?@!%^~ and null`,
	arrayOfObject: {
		UserCodes: 'UserCodes',
		Parameters: 'Parameters',
		DeviceTypes: 'DeviceTypes'
	},
	dataSourceValidation: ['Tracking System', 'CAT Export Tracker'],
	userSyncExportValidatiaon: ['Users'],
	customeErrorValidataion: ['UserCodes', 'ItemCodes', 'Parameters'],
	UserGroups: [
		'{Engineering, Supplier}',
		'{Production, Supplier}',
		'{Service, Supplier}',
		'Administrator, Hospital',
		'Maintenance, Hospital',
		'Nurse Manager, Hospital',
		'Operators, Hospital',
		'Supervisor, Hospital'
	],
	InitialRegions: [
		{
			RegionName: 'North America',
			RegionId: '1',
			Active: false
		},
		{
			RegionName: 'South America',
			RegionId: '2',
			Active: false
		},
		{
			RegionName: 'Europe',
			RegionId: '3',
			Active: false
		},
		{
			RegionName: 'Asia/Pacific',
			RegionId: '4',
			Active: false
		}
	],
	serialNumberValidatiaon: ['CT', 'ETS', 'RM', 'R', 'T'],
	linkToTrackingSystemValidation: ['CT', 'ETS', 'T', 'R'],
	RoleCheck: ['Viewer', 'Administrator'],
	EquipmentFamilyID: {
		RelianceCabinet: '61f3fa6a056dc61044d087c1',
		EndoCabinet: '61f3fa6a056dc61044d087c3',
		Advantage: '61f3fa6a056dc61044d087c4',
		Reliance6500: '61f3fa6a056dc61044d087c3',
		Enspire3000: '6513526daaa28b6b8bbb938b',
		ENDO: '61f3fa6a056dc61044d087c3',
		UXMLEndoCabinet: '65d8889995a4821583eb2dc3',
		Robot: '65135dea2dc42fd25ae14c1a'
	},
	InterfaceType: {
		API: 'API'
	},
	DataSource: {
		CAT: 'CAT',
		HULU: 'HULU',
		TrackingSystem: 'Tracking System'
	},
	SuperAdminDefaultEmail: 'connectassuresupport@steris.com',
	MUIBIResultIcon: {
		Pending: {
			Icon: MoreHorizIcon,
			Color: 'warning'
		},
		Error: {
			Icon: PriorityHighIcon,
			Color: 'error'
		},
		TestPositive: {
			Icon: Add,
			Color: 'error'
		},
		TestNegative: {
			Icon: Remove,
			Color: 'success'
		},
		ControlPositive: {
			Icon: Remove,
			Color: 'error'
		},
		ControlNegative: {
			Icon: Add,
			Color: 'success'
		}
	},
	selectedUserSyncDeviceType: ['C', 'E', 'RC', 'I', 'INNOV', 'L', 'RAER', 'R', 'S', 'V', 'W', 'ADV', 'ADVPT', 'EDRY', 'ELC', 'ISA', 'DH'],
	allUserSyncDeviceType: ['C', 'RC', 'I', 'L', 'R', 'S', 'V', 'W', 'RAER', 'INNOV', 'E', 'ADV', 'ADVPT', 'EDRY', 'ELC', 'ISA', 'DH'],
	DeviceType: {
		ADV: 'Advantage Plus',
		ADVPT: 'Advantage Plus PT',
		CT: 'CAT Export Tracker',
		ELC: 'enspire LC',
		C: 'Endo Cabinet',
		E: 'Endo Washer',
		EDRY: 'EndoDry',
		ETS: 'External Tracking System',
		ISA: 'ISA',
		I: 'Incubator',
		INNOV: 'Innova',
		L: 'Liquid Chemical Sterilizer',
		RM: 'RFID Middleware',
		RAER: 'RapidAER',
		R: 'Robot',
		S: 'Steam Sterilizer',
		T: 'Tracking System',
		V: 'VHP Sterilizer',
		W: 'Washer',
		CSIQ: 'CS-iQ',
		RC: 'Reliance Cabinet',
		RA: "Rapid AER",
		DH: "DSD"
	},
	WasterPort: {
		FilteredWater: '9'
	},
	GaugeChart: {
		MaxScale: 1800,
		MidScale: 1650
	},
	ModelDataType: {
		Endo: '6513558c5dc83054d02a613d'
	},
	requiredDeviceType: ['6513529865d3d0829129f8b1', '6513528f15d865f2f425d213', '65135284c0a2a13d232a4d8c', '654ac90a4b7f64ef9d97b637', '61f3fa6a056dc61044d087c3', '6513526daaa28b6b8bbb938b', '6513521cffe56d331347e315', '65135203f743ac156dcb6560', '65d88b12d2551c1a97e1ba01'],
	ModelDeviceType: {
		'6513529865d3d0829129f8b1': 'Adv',
		'6513528f15d865f2f425d213': 'EndoCabinet',
		'65135284c0a2a13d232a4d8c': 'EndoDry',
		'6513526daaa28b6b8bbb938b': 'Enspire3000',
		'61f3fa6a056dc61044d087c3': 'Reliance6500',
		'654ac90a4b7f64ef9d97b637': 'ADVPT',
		'6513521cffe56d331347e315': 'RapidAER',
		'65135203f743ac156dcb6560': 'ISA',
		'65d88b12d2551c1a97e1ba01': 'DSD Horizon'
	},
	MqttPubAllowTopics: ['scopefile', 'physicianfile', 'userfile'],
	PhysicianUserType: 'Physician',
	AssistantUserType: 'Assistant',
	publishComparisonObj: [
		{ key: 'cmd/#', value: '+/cmd', blankKeys: [''] },
		{ key: '+/cmd', value: 'cmd/#', blankKeys: ['CmdPermission', 'PublishDeviceType', 'PublishCmdData'] },
		{ key: 'data/#', value: '+/data', blankKeys: [] },
		{ key: '+/data', value: 'data/#', blankKeys: ['DataPermission', 'PublishData'] },
		{ key: 'tdata/#', value: '+/tdata', blankKeys: [] },
		{ key: '+/tdata', value: 'tdata/#', blankKeys: ['TDataPermission', 'PublishTData'] }
	],
	subComparisonObj: [
		{ key: 'cmd/#', value: '+/cmd', blankKeys: [''] },
		{ key: '+/cmd', value: 'cmd/#', blankKeys: ['SubCmdPermission', 'SubscribeCmdData'] },
		{ key: 'data/#', value: '+/data', blankKeys: [] },
		{ key: '+/data', value: 'data/#', blankKeys: ['SubDataPermission', 'SubscribeData'] },
		{ key: 'tdata/#', value: '+/tdata', blankKeys: [] },
		{ key: '+/tdata', value: 'tdata/#', blankKeys: ['SubTDataPermission', 'SubscribeTData'] }
	],
	trackingSystemIdentifierRegax: /Tracking System/i,
	CantelTimeFormat: 'YYYY-MM-DDTHH-mm-ss-SSS',
	rolesAllowedToModify: ['steris admin', 'superadmin', 'supervisor', 'steris specialist', 'physician admin'],
	AERModelDeviceType: '6513529865d3d0829129f8b1',
	requiredRole: ['supervisor', 'steris specialist', 'operator', 'physician admin'],
	requiredRoleForHelp: ['supervisor', 'steris specialist', 'operator', 'physician admin', 'steris admin'],
	languageMapper: {
		'en': 'English',
		'fre': 'French',
		'de': 'German',
		'it': 'Italian',
		'es': 'Spanish',
		'pt': 'Portuguese',
		'sv': 'Swedish'
	},
	endoManagementRoute: ["/endoCycleslist", "/endoSetup", "/endoSetupUser", "/endoSetupPhysician", "/scopeRegion"],
	URLPathRegex:
		/^(?:(?:https?|ftp|file):\/\/)?((?:(?:[1-9]|[1-9][0-9]|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:[a-z0-9]-*)*[a-z0-9]+)(?:\.(?:[a-z0-9]-*)*[a-z0-9]+)*(?:\.(?:[a-z]{2,})))|localhost)(?::[0-9]{2,5})?(?:\/[^\s]*)?$/i,
	UNCPathRegex: /^(\\\\|\/\/)[a-zA-Z0-9\.\-_]{1,}(((([\\\/]{1,})?)[a-zA-Z0-9\-_]{1,}){1,})(([\\\/]{1,})?)[\$]{0,1}/, // Captures paths like \\Win-l661f0vvc95\13108764\
	SubPermissionObj: {
		data: 'SubDataPermission',
		cmd: 'SubCmdPermission',
		tdata: 'SubTDataPermission'
	},
	PubPermissionObj: {
		data: 'DataPermission',
		cmd: ['CmdPermission', 'PublishDeviceType'],
		tdata: 'TDataPermission'
	},
	PubPermissionObjTopic: {
		data: 'PublishData',
		cmd: ['PublishCmdData', 'PublishDeviceType'],
		tdata: 'PublishTData'
	},
	SubPermissionObjTopic: {
		data: 'SubscribeData',
		cmd: 'SubscribeCmdData',
		tdata: 'SubscribeTData'
	},
	nonParsableTopics: ['usersyncts', 'itemsyncts', 'cycleheader', 'cyclestart', 'updatecertreq', 'updateloglevel'],
	biConfigId: "61800cec426b04de6c397195",
	incubatorDeviceType: "I",
	biConfigCommand: "biconfigreq",
	updateConfigCommand: "updateconfig",
	defaultEndoSetupUser : '6123c4eb79f0fa4c6ddab4c6',
	catDataAdminRoute: ["/usersync", "/itemsync", "/interfaceConfig", "/interfacelogs"],
	infoLevel: '661793f04f05b214b7e0c683',
	updateLogLevel:'66289711ec60e12a741b724a',
	logLevels: {
		'661793f04f05b214b7e0c681': 'Verbose',
		'661793f04f05b214b7e0c682': 'Debug',
		'661793f04f05b214b7e0c683': 'Information',
		'661793f04f05b214b7e0c684': 'Warning',
		'661793f04f05b214b7e0c685': 'Error',
		'661793f04f05b214b7e0c686': 'Fatal'
	},
	DefaultLogLevelService: '661793f04f05b214b7e0c691',
	logServices: {
		'661793f04f05b214b7e0c691': 'ABPLC',
		'661793f04f05b214b7e0c692': 'BarCodeService',
		'661793f04f05b214b7e0c693': 'CenturyAnalogData',
		'661793f04f05b214b7e0c694': 'ConsoleBus',
		'661793f04f05b214b7e0c695': 'CycleDataService',
		'661793f04f05b214b7e0c696': 'DeviceDataAnalyzer',
		'661793f04f05b214b7e0c697': 'IOBus',
		'661793f04f05b214b7e0c698': 'IRDS',
		'661793f04f05b214b7e0c699': 'Kodiak',
		'661793f04f05b214b7e0c610': 'LTEMConnectionService',
		'661793f04f05b214b7e0c611': 'MonitorService'
	},
	ModelExportFormate :{
		'EndoCabinet': '.csv',
		'EndoDry': '.csv',
		'Adv': '.STRX',
		'Enspire3000': '.gz',
		'Reliance6500': '.gz'
	},
	commandIndex: 1,
	firstItemIndex: 0,
	hashSign: '#',
	successResponse: 200,
	setTopicId: '664ddfefec7b7312cd6e7b9f',
	regex: {
		jsonExtenion: /\.gz$/i,
		DateExtract: /(\$D\{|\})/g,
		curlyBraceReg: /^\{|\}$/g,
		AERXMLReg: /^ADV|AER - XML$/,
		Cleaning: /^Cleaning$/i,
		Cleaning1: /^Cleaning 1$/i,
		Cleaning2: /^Cleaning 2$/i,
		PreRinse: /^pre[\s-]?rinse$/i,
		PostRinse: /^post[\s-]?rinse$/i,
		Disinfection: /^disinfection$/i,
		Alcohol: /^alcohol$/i,
		System1Endo2: /^system\s*1\s*endo\s*2$/i,
		System1E: /^system\s*1\s*e$/i,
		WaterFill: /^water\s*fill$/i,
		Rinse1: /^rinse\s*[-\s]?1$/i,
		Rinse2: /^rinse\s*[-\s]?2$/i,
		WarmMix: /^warm\s*[\/\s]?mix$/i,
		Exposure: /^exposure$/i,
		LeakTest: /^leak\s*test$/i,
		ISA: /^isa$/i,
		RapidAER: /^rapid\s*aer$/i,
		AdminOrViewer: /^(super\s*admin|administrator|viewer)$/i,
		relianceCabinetReg: /^reliance cabinet$/i,
		IsaOrRepidAer: /^isa$|^rapidaer$/i,
		mongoId:/^[0-9a-fA-F]{24}$/,
		removeSpace: /\s+/g,
		hexValue: /^[0-9A-Fa-f]+$/,
		physicianAssistantRole: /^(physician|assistant)$/i,
		multiScopeFile: /^(rapid\s*aer|ADV\+|ADVPT|ADV\+\s*PT)$/i,
		decimalValue: /^[0-9]+$/
	},
	commandHistory: 'CommandHistory',
	updateLogLevelId: "61800cec426b04de6c39719d",
	userType: "EndoSetupPhysician",
	fileExtensionRegex: {
		user: /\.usrx$/i,
		strx: /\.strx$/i,
		xlsx: /\.xlsx$/i
	},
	fileTypes: ['text/csv', 'application/x-gzip', 'application/json', 'text/plain'],
	DeviceTypeMapper: {
		'6513529865d3d0829129f8b1': 'ADV',
		'6513528f15d865f2f425d213': 'C',
		'65135284c0a2a13d232a4d8c': 'EDRY',
		'654ac90a4b7f64ef9d97b637': 'ADVPT',
		'61f3fa6a056dc61044d087c3': 'RC',
		'6513526daaa28b6b8bbb938b': 'ELC',
		'6513521cffe56d331347e315': 'RAER',
		'65135203f743ac156dcb6560': 'ISA',
		'65d88b12d2551c1a97e1ba01': 'DH',
	},
	mqttPayloadEnums: {
		cyclefileData: 3,
		cyclefileresData: 6
	},
	cyclefileres: 'cyclefileres',
	unpublishedfiles: 'unpublishedfiles',
	nonPluralizedLabels: ['Dashboard', 'Cycle Action Status', 'Equipment Model', 'Role Module', 'User Type', 'Monitoring By Tag', 'Task Assignment', 'User Sync', 'Item Sync', 'Endo Setup', 'Transaction', 'Scope Region', 'Interface Config', 'Endo Setup User', 'Endo Setup Physician', 'Language Mapper', 'Topic Permission', 'Equipment Type', 'Task Type', 'Indicator Model', 'Indicator Lot Detail', 'Reusable Test Pack'],
	allPermission: '11111111',
	noPermission: '00000000',
	ParentMenu: [
		'Admin',
		'Broker',
		'RFID',
		'Master Data',
		'Transactions',
		'Endo Management',
		'Equipment (Module)',
		'Task',
		'Cat Data Admin',
		'Cat Data Sync',
		'Inventory',
		'Setup'
	],
	checkIcon: 'fa fa-check icon-check',
	crossIcon: 'fa fa-times icon-times',
	CleanExposureTime: 'CleanExposureTime',
	testConnection: 'testConnection',
	Duplicate: 'Duplicate',
	ModelDeviceTypes: {
		RAPIDAER: '6513521cffe56d331347e315'
	},
	nonHuluScopes: ['RC', 'EDRY', 'C'],
	channelPointerLocationValue: {
		inActive: {
			barPointerValue: 0,
			value: 0
		},
		pass: {
			barPointerValue: 2.5,
			value: 1
		},
		blocked: {
			barPointerValue: 0.85,
			value: 2
		},
		disconnected: {
			barPointerValue: 4.25,
			value: 3
		},
		notFlushed: {
			barPointerValue: 0,
			value: 4
		}
	},
	adminModuleUserType: {
		AdministratorUserType: 'Supervisors/Admin',
		OperatorUserType: 'Operators'
	},
	codeType: {
		RFIDCodeType: "RFID"
	},
	empty: 'Empty',
	topSection: {
		isaAndRaerTopSection: 'ISAANDRAERTopSection',
		advantageChemistryTopSection: 'AdvantageChemistryTopSection',
		advantageCycleTopSection: 'AdvantageCycleTopSection'
	},
	limit: {
		departmentLookup: 100
	},
	roleArrayForViewXML: ["Supervisor", "Department", "Operator"],
	processMonitoring: 'ProcessMonitoring',
	maxUserCount: 250,
	maxScopesCount: 1000,
	incubatorTest: 0,
	incubatorControl: 1,
	itemType: {
		scopes: "Scope",
		hookup: "hookup"
	},
	usersType: [
		'EndoSetupUser',
		'UserSync',
		'EndoSetupPhysician'
	],
	topicPermissionsMap: {
		data: 'MqttDataPermissionTopic',
		cmd: 'MqttCommandPermissionTopic',
		tdata: 'MqttTelemetryPermissionTopic'
	},
	endoImportSpec: {
		Users: {
			fileType: ".xlsx,.csv,.USRX,.gz,.XSRX,.json,.txt",
			type: 'Users'
		},
		Scopes: {
			fileType: ".xlsx,.csv,.gz,.STRX,.json,.txt",
			type: 'Scopes'
		},
		Hookups: {
			fileType: ".txt",
			type: 'Hookups'
		},
		EndoSetupUsers: {
			fileType: ".xlsx,.csv,.USRX,.gz,.json,.txt",
			type: 'Users'
		},
		Physicians: {
			fileType: ".xlsx,.XSRX,.json",
			type: 'Users'
		}
	},
	dateTimeTypes: ['datetime', 'date', 'dateTime'],
	sensitiveKeys: [
		'BrokerServerKey',
		'BrokerServerCertificate',
		'BrokerServerCA',
		'SSLKeyFilePath',
		'SSLCertFilePath',
		'CaBundlePath',
		'SMTPFrom',
		'SMTPHost',
		'SMTPPassword',
		'SMTPTo',
		'SMTPUserName',
		'UserName',
		'AuthorizationToken',
		'Password',
		'ConfirmUserPassword',
		'Email',
		'FirstName',
		'LastName',
		'ScopeMongoDBConnectionString',
		'ScopeMongoDBDatabaseName',
		'RunDBUpgrade'
	],
	passwordStringMapper: {
		"Easy": "PasswordEasyValidationError",
		"Medium": "PasswordMediumValidationError",
		"Strong": "PasswordValidationError"
	},
	codeTypeISA:'RFID ISA',
	rfidOptions: ['RFID ISA', 'RFID RAER', 'Barcode'],
	rfidValidation: ['RFID ISA', 'RFID RAER'],
	licenseType: {
		core: 'Core',
		client: 'Client'
	},
	multitenancyVersion: 5.5,
	codeTypeRAER:'RFID RAER'
}
